/* eslint-disable no-new */
/* eslint-disable no-undef */


import Vue from "vue";
import App from "./App";
import router from "./router";
import axios from "axios";
import store from "./store";
import myHttp from "./assets/js/public/http";
import VueClipboard from 'vue-clipboard2';
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'


import Icon from "vue-svg-icon/Icon.vue";
import ba from "vue-ba";
import {
getSStore,
setChannel,
IsValid,
getLStore,
setSStore,
deviceIsIOS,
hashQuery
} from "@js/public/mUtils";

if (hashQuery('wxExpose')) {
sessionStorage.clear();
localStorage.clear();
}

import echarts from "echarts/lib/echarts";
import { trueFunc } from "boolbase";

import WXConfig from './assets/js/wx.jsapi.js' 
Vue.prototype.WXConfig = WXConfig


require("echarts/lib/chart/line");
require("echarts/lib/chart/pie");

require("echarts/lib/component/tooltip");
require("echarts/lib/component/title"); 


Vue.use(AlertPlugin);
Vue.use(ToastPlugin);
Vue.use(LoadingPlugin);
Vue.use(ConfirmPlugin);
Vue.use(VueClipboard);


Vue.prototype.$http = axios;
axios.post = myHttp.post;
axios.get = myHttp.get;
axios.uploadPost = myHttp.uploadPost;
axios.corsPost = myHttp.corsPost;

Vue.config.productionTip = false;


Vue.config.errorHandler = function (err, vm, info) {
console.log(err);
console.log(vm);
console.log(info);



};
Vue.component("icon", Icon);

if (process.env.NODE_ENV === "development") {













axios.defaults.baseURL = "http://10.191.0.47:9400/api"; 



Vue.use(ba, "4349f62f97f1647927ddd256f544acb3");
} else {

axios.defaults.baseURL =
window.location.protocol + "//" + window.location.host + "/api";

Vue.use(ba, "e2758e6195668dcb30aacc9a917e3a79");
}




const serverUrl = 'https://testanalysisapi.cjhxfund.com:8106/sa?project=default';
const serverUrl2 = 'https://analysisapi.cjhxfund.com:8106/sa?project=production';

import sensors from './assets/js/sa-sdk-javascript/sensorsdata.es6.min.js';
sensors.init({
server_url: location.hostname==='wx.cjhxfund.com'?serverUrl2:serverUrl,
use_client_time: true,
send_type: 'beacon',
heatmap: {
clickmap: 'default',
scroll_notice_map: 'default'
},
show_log: false
});
sensors.registerPage({ product_platform: '微信直销' });
sensors.quick('autoTrack');
Vue.prototype.sa = sensors;


var FastClick = require("fastclick");
FastClick.attach(document.body);

FastClick.prototype.focus = function (targetElement) {
var length;
if (
deviceIsIOS() &&
targetElement.setSelectionRange &&
targetElement.type.indexOf('date') !== 0 &&
targetElement.type !== 'time' &&
targetElement.type !== 'month'
) {
length = targetElement.value.length;
targetElement.setSelectionRange(length, length);

targetElement.focus();
} else {
targetElement.focus();
}
};


Vue.prototype.toPage = function (path, query) {
router.push({
path: path,
query: query,
});
};

Vue.prototype.toBack = function () {
router.back();
};

Vue.directive("title", {
inserted: function (el, binding) {
document.title = el.innerText;
el.remove();
},
});

Vue.prototype.loaded = function () {
store.commit("updateLoadingStatus", {
isLoading: false,
});
};

Vue.prototype.load = function () {
store.commit("updateLoadingStatus", {
isLoading: true,
});
};
Vue.prototype.mainLoaded = function (_this) {
_this.main = true;
};


Vue.prototype.eventBus = new Vue();


Vue.prototype.echarts = echarts;



setChannel(); 
IsValid(getLStore("token")) && setSStore("token", getLStore("token")); 




router.beforeEach(function (to, from, next) {
Vue.prototype.fromRoute = from;
if (to.name === "registerCheck") {
if(from.name === 'completeRegister') {
router.push({
path: "/login",
query: {},
});
}
}
if (to.name === "registerCheck") {
if(from.name === 'completeRegister') {
router.push({
path: "/login",
query: {},
});
}
}

if (
to.name !== "login" &&
to.name !== "buy" &&
to.name !== "buyResult" &&
to.name !== "collect" &&
to.name !== "dealDetail" &&
to.name !== "register" &&
to.name !== "riskTest" &&
to.name !== "riskTestResult" &&
to.name !== "tiedCard" &&
to.name !== "tiedCardResult" &&
to.name !== "sale" &&
to.name !== "saleResult" &&
to.name !== "editMes" &&
getSStore("source") === "yx"
) {
alert("此渠道不能进入此页面");
return;
}


var tf = to.fullPath;
if (to.path) {
if (window._hmt) {
ba.trackPageview("/#" + tf);
}
}



if (to.name === "purchase" || to.name === "buyResult" || to.name === "timeInvestBuyResult") {

if (from.name !== "home" && from.name !== "buy" && from.name !== "timeInvestBuy" && from.name !== "dealDetail" && from.name !== "commonQuestion" && from.name !== "all"  && from.name !== "holdDetail") {
router.push({
path: "/comeIn/home",
query: {},
});
}
}








store.commit("updateLoadingStatus", {
isLoading: true,
});
/* 路由发生变化修改页面title */
console.log("title7789:" + to.meta.title);
if (
to.meta.title === undefined ||
to.meta.title === null ||
to.meta.title === ""
) {
document.title = "创金合信基金";
} else {
document.title = to.meta.title;
}
next();
});

router.afterEach(function (to, from) {
try {
document.documentElement.scrollTop = 0;
document.body.scrollTop = 0;
} catch (err) {
console.log(err);
}
store.commit("updateLoadingStatus", {
isLoading: false,
});

if (from.name == "productDetail" && to.name == "buy") {

setSStore("clearBuyInput", true)
}

if (from.name == "cjBao" && to.name == "buy") {

setSStore("clearBuyInput", true)
}
});



var requireAll = (requireContext) => requireContext.keys().map(requireContext);

var req = require.context("./assets/svg", true, /\.svg$/);
requireAll(req);

new Vue({
el: "#app",
router,
store,
components: {
App,
},
template: "<App/>",
});



// WEBPACK FOOTER //
// ./src/main.js